'use client'

import { SearchableFilters } from '@web/components/content-api/search-page/utils'
import { SidebarFilter } from './sidebar-filter'
import { useSearchPageContext } from '@web/components/algolia/providers/content-api-search-page-provider'

export function ObjectsSidebarFilter({
  header,
  showLessText,
  showMoreText,
}: {
  header: string
  showMoreText: string
  showLessText: string
}) {
  const { expanded, contentLanguage } = useSearchPageContext()
  return (
    <SidebarFilter
      isExpanded={expanded ? expanded.includes(SearchableFilters.OBJECTS) : undefined}
      showLessText={showLessText}
      showMoreText={showMoreText}
      attribute={`imageAnalysis.${contentLanguage}.${SearchableFilters.OBJECTS}`}
      header={header}
    />
  )
}
